import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-12 bg-secondary-950 text-background-300">
      <div className="w-full px-4 md:px-6 py-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center text-secondary-950">
                <i className="ri-vip-diamond-line text-xl" />
              </span>
              <span className="font-heading font-bold text-lg text-primary-400">
                黄金软件下载站
              </span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-background-400">
              黄金网站软件app免费，专注为黄金投资人整理实用的行情分析、价格监控与理财工具软件。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-3">
              <Link to="/softwares" className="cursor-pointer hover:text-primary-400 transition-colors">
                软件分类
              </Link>
            </h4>
            <ul className="flex flex-col gap-2 text-sm">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.id}`}
                    className="cursor-pointer hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-3">快捷链接</h4>
            <ul className="flex flex-col gap-2 text-sm">
              <li>
                <Link to="/" className="cursor-pointer hover:text-primary-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/softwares" className="cursor-pointer hover:text-primary-400 transition-colors">
                  全部软件
                </Link>
              </li>
              <li>
                <Link to="/about" className="cursor-pointer hover:text-primary-400 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/search" className="cursor-pointer hover:text-primary-400 transition-colors">
                  搜索
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-3">联系我们</h4>
            <ul className="flex flex-col gap-2 text-sm">
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center text-primary-400">
                  <i className="ri-mail-line text-base" />
                </span>
                support@gold-software.example.com
              </li>
              <li className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center text-primary-400">
                  <i className="ri-time-line text-base" />
                </span>
                周一至周五 09:00 - 18:00
              </li>
              <li className="flex items-center gap-3 pt-1">
                {['ri-wechat-line', 'ri-weibo-line', 'ri-telegram-line'].map((icon) => (
                  <span
                    key={icon}
                    className="w-8 h-8 rounded-md bg-secondary-800 flex items-center justify-center text-background-200 cursor-pointer hover:bg-primary-500 hover:text-secondary-950 transition-colors"
                  >
                    <i className={`${icon} text-base`} />
                  </span>
                ))}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <p>© {year} 黄金网站软件app免费 · 保留所有权利</p>
          <p className="text-center sm:text-right">
            本站为演示站点，下载链接均为示范地址，不提供真实下载服务。
          </p>
        </div>
      </div>
    </footer>
  );
}